import { html, nothing } from "lit";
import { BaseComponent } from "../../BaseComponent.js";
import { prop } from "../../../decorators/prop/index.js";
import { defineElement } from "../../../decorators/defineElement.js";
import { preventDefault } from "../../../decorators/preventDefault.js";
import { state } from "lit/decorators.js";
import { when } from "lit-html/directives/when.js";
import { ifDefined } from "lit-html/directives/if-defined.js";
import "../../atom/Icon/index.js";
import "../../atom/Column/index.js";
import "../../atom/Text/index.js";
import "../Button/index.js";
import "../FileInput/index.js";
import { getWrapperClasses, getTitleClasses, getDescriptionClasses, getDropzoneClasses } from "./utils.js";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result) __defProp(target, key, result);
  return result;
};
let DsfDropzone = class extends BaseComponent {
  constructor() {
    super();
    this.isDragging = false;
    this.onDragStart = this.onDragStart.bind(this);
    this.onDragEnd = this.onDragEnd.bind(this);
    this.onDrop = this.onDrop.bind(this);
  }
  get parentZone() {
    return this.dsf_parent_zone ? document.querySelector(this.dsf_parent_zone) : null;
  }
  get mimeTypes() {
    var _a;
    return ((_a = this.dsf_accepted_mime_types) == null ? void 0 : _a.split(",").map((mime) => mime.trim())) || [];
  }
  update(changedProperties) {
    super.update(changedProperties);
    if (changedProperties.has("dsf_parent_zone")) {
      const oldParent = changedProperties.get("dsf_parent_zone");
      if (oldParent) {
        this.removeListeners(oldParent);
      }
      this.parentZone && this.addListeners(this.parentZone);
    }
  }
  connectedCallback() {
    super.connectedCallback();
    this.addListeners(this);
    this.parentZone && this.addListeners(this.parentZone);
  }
  disconnectedCallback() {
    super.disconnectedCallback();
    this.removeListeners(this);
    this.parentZone && this.removeListeners(this.parentZone);
  }
  addListeners(to) {
    to.addEventListener("drop", this.onDrop);
    to.addEventListener("dragenter", this.onDragStart);
    to.addEventListener("dragover", this.onDragStart);
    to.addEventListener("dragleave", this.onDragEnd);
    to.addEventListener("dragend", this.onDragEnd);
  }
  removeListeners(to) {
    to.removeEventListener("drop", this.onDrop);
    to.removeEventListener("dragenter", this.onDragStart);
    to.removeEventListener("dragover", this.onDragStart);
    to.removeEventListener("dragleave", this.onDragEnd);
    to.removeEventListener("dragend", this.onDragEnd);
  }
  isFileValid(file) {
    if (this.mimeTypes.length === 0) {
      return true;
    }
    return this.mimeTypes.some((type) => file.type.match(type));
  }
  onDragStart() {
    if (!this.disabled) {
      this.isDragging = true;
    }
  }
  onDragEnd() {
    this.isDragging = false;
  }
  onDrop(e) {
    var _a, _b;
    this.isDragging = false;
    if (!this.disabled && ((_a = e.dataTransfer) == null ? void 0 : _a.files) && ((_b = e.dataTransfer) == null ? void 0 : _b.files.length) > 0) {
      const files = [...e.dataTransfer.files].reduce(
        (files2, file) => {
          if (this.isFileValid(file)) {
            files2.valid.push(file);
          } else {
            files2.invalid.push(file);
          }
          return files2;
        },
        { valid: [], invalid: [] }
      );
      if (files.valid.length > 0) {
        this.emit({ name: "files", payload: files.valid });
      }
      if (files.invalid.length > 0) {
        this.emit({ name: "invalid-files", payload: files.invalid });
      }
    }
  }
  render() {
    return html`
      <dsf-col>
        <div class=${getWrapperClasses(this)}>
          <dsf-icon dsf_name="FileText" class="text-neutral-300"></dsf-icon>
          <p class=${getTitleClasses(this)}>${this.dsf_title}</p>
          <p class=${getDescriptionClasses(this)}>${this.dsf_description}</p>
          ${when(
      this.dsf_button_text,
      () => html` <dsf-file-input
              dsf_level="secondary"
              dsf_multiple
              dsf_label=${this.dsf_button_text}
              dsf_accepted_mime_types=${ifDefined(this.dsf_accepted_mime_types)}
              ?disabled=${this.disabled}
            ></dsf-file-input>`,
      () => nothing
    )}
          ${when(
      this.isDragging,
      () => html`
              <div class=${getDropzoneClasses()}>
                <dsf-text dsf_level="xs-semibold" dsf_color_intensity="400"
                  >${this.dsf_drop_prompt}</dsf-text
                >
              </div>
            `,
      () => nothing
    )}
        </div>
        ${when(
      this.dsf_error_message,
      () => html`<dsf-text class="dsf-pt-xs" dsf_level="xxs" dsf_color="error"
              >${this.dsf_error_message}</dsf-text
            > `,
      () => nothing
    )}
      </dsf-col>
    `;
  }
};
__decorateClass([
  prop({ type: String })
], DsfDropzone.prototype, "dsf_accepted_mime_types", 2);
__decorateClass([
  prop({ type: String })
], DsfDropzone.prototype, "dsf_parent_zone", 2);
__decorateClass([
  prop({ type: String })
], DsfDropzone.prototype, "dsf_error_message", 2);
__decorateClass([
  prop({ type: Boolean })
], DsfDropzone.prototype, "disabled", 2);
__decorateClass([
  prop({ type: String })
], DsfDropzone.prototype, "dsf_title", 2);
__decorateClass([
  prop({ type: String })
], DsfDropzone.prototype, "dsf_description", 2);
__decorateClass([
  prop({ type: String })
], DsfDropzone.prototype, "dsf_drop_prompt", 2);
__decorateClass([
  prop({ type: String })
], DsfDropzone.prototype, "dsf_button_text", 2);
__decorateClass([
  state()
], DsfDropzone.prototype, "isDragging", 2);
__decorateClass([
  preventDefault
], DsfDropzone.prototype, "onDragStart", 1);
__decorateClass([
  preventDefault
], DsfDropzone.prototype, "onDragEnd", 1);
__decorateClass([
  preventDefault
], DsfDropzone.prototype, "onDrop", 1);
DsfDropzone = __decorateClass([
  defineElement("dsf-dropzone")
], DsfDropzone);
export {
  DsfDropzone
};
